module.exports = __webpack_public_path__ + "img/note_alt_outlined.17e3b1f2.svg";